import React from "react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Textarea } from "../ui/textarea";

export function ServiceFormFields({
  formData,
  setFormData,
  categories,
  units,
  calculateMargin,
}) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <div className="space-y-2 sm:col-span-2">
        <Label className="text-[#9CA3AF]">Nombre del Servicio *</Label>
        <Input
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          className="bg-[#0B0E14] border-[#242E42]"
          required
        />
      </div>

      <div className="space-y-2">
        <Label className="text-[#9CA3AF]">Categoria</Label>
        <Select
          value={formData.category}
          onValueChange={(value) => setFormData({ ...formData, category: value })}
        >
          <SelectTrigger className="bg-[#0B0E14] border-[#242E42]">
            <SelectValue placeholder="Seleccionar..." />
          </SelectTrigger>
          <SelectContent>
            {categories.map((category) => (
              <SelectItem key={category} value={category}>
                {category}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label className="text-[#9CA3AF]">Unidad</Label>
        <Select
          value={formData.unit}
          onValueChange={(value) => setFormData({ ...formData, unit: value })}
        >
          <SelectTrigger className="bg-[#0B0E14] border-[#242E42]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {units.map((unit) => (
              <SelectItem key={unit.value} value={unit.value}>
                {unit.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label className="text-[#9CA3AF]">Costo Unitario (Tu Costo) *</Label>
        <Input
          type="number"
          step="0.01"
          value={formData.cost_price}
          onChange={(e) => setFormData({ ...formData, cost_price: e.target.value })}
          className="bg-[#0B0E14] border-[#242E42]"
          required
        />
      </div>

      <div className="space-y-2">
        <Label className="text-[#9CA3AF]">Precio de Venta (Al Cliente) *</Label>
        <Input
          type="number"
          step="0.01"
          value={formData.sale_price}
          onChange={(e) => setFormData({ ...formData, sale_price: e.target.value })}
          className="bg-[#0B0E14] border-[#242E42]"
          required
        />
      </div>

      {formData.cost_price && formData.sale_price ? (
        <div className="rounded-lg border border-[#242E42] bg-[#0B0E14] p-3 sm:col-span-2">
          <div className="flex items-center justify-between">
            <span className="text-sm text-[#9CA3AF]">Margen de Ganancia:</span>
            <span
              className={`text-lg font-bold ${
                parseFloat(calculateMargin()) < 0 ? "text-red-400" : "text-emerald-400"
              }`}
            >
              {calculateMargin()}%
            </span>
          </div>
        </div>
      ) : null}

      <div className="space-y-2 sm:col-span-2">
        <Label className="text-[#9CA3AF]">Descripcion</Label>
        <Textarea
          value={formData.description}
          onChange={(e) =>
            setFormData({ ...formData, description: e.target.value })
          }
          className="bg-[#0B0E14] border-[#242E42] min-h-[80px]"
          placeholder="Descripcion detallada del servicio..."
        />
      </div>
    </div>
  );
}
